module.exports = __webpack_public_path__ + "img/xiaomi-bk.62c3a7b1.svg";